import { useState, useEffect, useRef } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import { ReactComponent as XmarkCircleIcon } from '../../icons/xmark-circle.svg';

const Input = ({ name, value, label, type, error, onChange, onFocus, onBlur, clearable = false }) => {
  const { t } = useTranslation();
  const [displayedError, setDisplayedError] = useState(error);
  const [exiting, setExiting] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (error) {
      setDisplayedError(error);
      setExiting(false);
    } else if (displayedError) {
      setExiting(true);
      const timer = setTimeout(() => {
        setDisplayedError(null);
        setExiting(false);
      }, 250);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- runs on a change of error only
  }, [error]);

  const handleClear = () => {
    const fakeTarget = { name, value: '' };
    onChange({ target: fakeTarget, currentTarget: fakeTarget });
    inputRef.current?.focus();
  };

  return (
    <div className="mg-form-group">
      <label htmlFor={name} className="mg-sr-only">
        {label}
      </label>
      <div className={type === 'text' && clearable ? 'mg-input-clear-wrapper' : undefined}>
        <input
          ref={inputRef}
          id={name}
          name={name}
          value={value}
          placeholder={label}
          type={type}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          className={`mg-form-control ${name}`}
          {...(type === 'number' && { inputMode: 'numeric', pattern: '[0-9]*' })}
        />
        {type === 'text' && clearable && value && (
          <button
            type="button"
            className="mg-input-clear-btn"
            title={t('common.clear')}
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleClear}
          >
            <Icon icon={<XmarkCircleIcon />} />
          </button>
        )}
      </div>
      {displayedError && (
        <small className={cx('mg-form-text', 'mg-form-text--error', { exiting })}>{displayedError}</small>
      )}
    </div>
  );
};

export default Input;
